import { connector } from "../../common/connector";

export const getCategorias = (mercado_id) => {
    return connector.get(`api/mercados/${mercado_id}/categorias`);
}

export const getItems = (data) => {
    return connector.post('api/mercados/items', data);
}